/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { BackgroundContainer, ResponsiveContainer, SectionContainer } from "@components/elements/atoms";
import { ResearchCardOrganism } from "./ResearchCard.organism";
import type { ResearchCardOrganismProps } from "./ResearchCard.organism";
import { SectionConfigFragment } from "@cosmos/hygraph-schema";
import { VStack } from "@panda/jsx";
import { SectionHeading } from "../section-heading/SectionHeading.molecule";

export interface ResearchCardContainerProps extends ResearchCardOrganismProps {
	config?: SectionConfigFragment | null;
}

export const ResearchCardsContainer = ({
	config,
	items,
	...rest
}: ResearchCardContainerProps): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(items?.length);
	if (!validHeading && !validContent) return null;

	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.48">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <ResearchCardOrganism items={items} {...rest} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
